import { shallowMount } from "@vue/test-utils";
import SalesButton from "@/components/core/SalesButton";

describe("SalesButton component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(SalesButton);
  });

  it("Renders del component SalesButton", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
